// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const PinFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M 12.001,19.677 C 0,0 0,0 12.001,19.677 Z m 0,1.342 C 9.651,18.941 7.881,17.003 6.691,15.205 5.5,13.407 4.904,11.771 4.904,10.296 4.904,8.181 5.594,6.436 6.971,5.062 8.348,3.686 10.025,3 12,3 c 1.975,0 3.652,0.687 5.03,2.061 1.377,1.375 2.066,3.12 2.066,5.235 0,1.475 -0.596,3.11 -1.786,4.909 -1.19,1.798 -2.96,3.736 -5.31,5.814 z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const PinFillOffset: IconOffset = {
    vertical: 12, // Store Custom Code
    horizontal: 20, // Store Custom Code
};

export default React.memo(PinFill);
